export default __webpack_public_path__ + "db7bba9.png";